import { Injectable } from "@angular/core";
import {
  ActionCatalogLoad,
  ActionNoop,
  ActionSearchComplete,
  ActionSearchProducts,
  ActionFetchOutOfStockProduct,
  ActionLoadOutofStockProducts,
  ActionLoadOutofStockFailed
} from "./catalog-actions";
import { Actions, Effect } from "@ngrx/effects";
import { ofAction } from "ngrx-actions";
import { map, mergeMap, switchMap, catchError } from "rxjs/operators";

import {
  FirebaseCatalogService,
  SearchService,
  OutOfStockProductsService
} from "@tendercuts/providers";
import { Product } from "@tendercuts/models";
import { of } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState } from "@store/state";
import { OutofStockProducts } from '../../models';

@Injectable()
export class CatalogEffects {
  constructor(
    private actions$: Actions,
    private firebaseCatalogService: FirebaseCatalogService,
    public outOfStockProductsService: OutOfStockProductsService,
    private searchService: SearchService,
    public store: Store<AppState>
  ) {}

  /**
   * Loads the catalog + inventory data & dispatches
   * -> ActionCatalogLoadSuccess on complete otherwise
   * -> ActionCatalogLoadFailed on fail otherwise
   *
   * @type {Observable<any>}
   */
  @Effect() catalogLoad$ = this.actions$.pipe(
    ofAction(ActionCatalogLoad),
    mergeMap((action: ActionCatalogLoad) => {
      this.firebaseCatalogService.startSubscription(action.payload.storeId);
      return of(new ActionNoop());
    })
  );

  /***
   * Triggers a search request & dispatches
   * -> ActionSearchComplete
   * @type {Observable<ActionSearchComplete>}
   */
  @Effect() searchProducts$ = this.actions$.pipe(
    ofAction(ActionSearchProducts),
    switchMap((action: ActionSearchProducts) =>
      this.searchService
        .searchProducts(action.payload)
        .pipe(map((products: Product[]) => new ActionSearchComplete(products)))
    )
  );

  /**
   * fetch the outofstock products from server
   * and load the out of stock products
   * by dispatch the ActionLoadOutofStockProducts
   */
  @Effect() loadOutofStockProducts$ = this.actions$.pipe(
    ofAction(ActionFetchOutOfStockProduct),
    switchMap((action: ActionFetchOutOfStockProduct) => {
      return this.outOfStockProductsService
        .getData(this.outOfStockProductsService.getParams(action.storeId))
        .pipe(
          map((response: OutofStockProducts[]) => {
            if (response) {
              return new ActionLoadOutofStockProducts(response);
            }
            return new ActionNoop();
          }),
          catchError(err => {
            return of(new ActionLoadOutofStockFailed(err));
          })
        );
    })
  );
}
